'use strict';

var config = [

    {

        route: '/company',

        method: ['GET'],

        controller: 'renderCompanyIndex',

        view: {
            route: 'company',
            alias: 'company-index',
            file: 'js/company-index.js'
        },

        timeout: 2000
    }

];

exports.config = config;
